const TAXES_INCLUDED_COUNTRIES = [
  'gb', // UK
  'gg', // UK
  'gi', // UK
  'im', // UK
  'is', // UK
  'je', // UK
  'at', // Austria
  'be', // Belgium
  'bg', // Bulgaria
  'cz', // Czech Republic
  'dk', // Denmark
  'fo', // Denmark
  'fi', // Finland
  'ax', // Finland
  'fr', // France
  'mc', // France
  'de', // Germany
  'li', // Germany
  'gr', // Greece
  'hu', // Hungary
  'ie', // Ireland
  'it', // Italy
  'sm', // Italy
  'va', // Italy
  'lv', // Latvia
  'lt', // Lithuania
  'lu', // Luxembourg
  'mt', // Malta
  'nl', // Netherland
  'no', // Norway
  'sj', // Norway
  'al', // Albania
  'ba', // Bosnia and Hercegovina
  'cy', // Cyprus
  'ee', // Estonia
  'hr', // Croatia
  'md', // Moldova
  'me', // Montenegro
  'rs', // Serbia
  'si', // Slovenia
  'pl', // Poland
  'pt', // Portugal
  'ro', // Romania
  'sk', // Slovakia
  'es', // Spain
  'ad', // Spain
  'se', // Sweden
  'ch', // Switzerland
  'py', // Paraguay
  'pe', // Peru
  'bo', // Bolivia
  'cr', // Costa Rica
  'gy', // Guyana
  'hn', // Honduras
  'ni', // Nicaragua
  'sr', // Suriname
  'sv', // El Salvador
  've', // Venezuela
];

export function useAreAllTaxesIncluded() {
  const localizationCountry = useLocalizationHeader();

  return computed(() =>
    TAXES_INCLUDED_COUNTRIES.includes(
      localizationCountry.value?.toLowerCase?.() ?? '',
    ),
  );
}
